import { render, staticRenderFns } from "./ElectionsVoteListNoCandidates.vue?vue&type=template&id=4ad59af8"
import script from "./ElectionsVoteListNoCandidates.vue?vue&type=script&lang=js"
export * from "./ElectionsVoteListNoCandidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports